<template>
  <div v-if="range !== null">
    <div class="range" v-bind:class="'range-' + result">
      <div class="item item-1">{{rangesText[0]}}</div>
      <div class="item item-2">{{rangesText[1]}}</div>
      <div class="item item-3">{{rangesText[2]}}</div>
      <div style="clear:both;"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Summary',
  props: {
    range: {
      type: Number
    },
    rangesText: {
      type: Array
    }
  },
  data: function () {
    return {
      message: '',
      result: 0
    }
  },
  mounted: function () {
    let self = this
    setTimeout(function () {
      self.result = self.range
      self.$emit('incrementPoints', self.range + 1)
    }, 1000)
  },
  created: function () {
    this.result = 0
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
$grey: #e9ecef;
$primary: #0069d9;
.range{
  border-radius: 50px;
  border:5px solid darken($grey,5);
  background: $grey;
  position: relative;
  z-index: 1;
  box-sizing: border-box;
  overflow: hidden;
  transition: 0.5s;
  -webkit-box-shadow: inset 0px 0px 5px 2px rgba(0,0,0,0.20);
  -moz-box-shadow: inset 0px 0px 5px 2px rgba(0,0,0,0.20);
  box-shadow: inset 0px 0px 5px 2px rgba(0,0,0,0.20);
  &:before{
    z-index: -1;
    position: absolute;
    top:0px;
    left:0%;
    width:33.33%;
    display: block;
    height:100%;
    content: " ";
    background-color: red;
    transition: 0.5s;
    -webkit-box-shadow: inset 0px 0px 5px 2px rgba(0,0,0,0.20);
    -moz-box-shadow: inset 0px 0px 5px 2px rgba(0,0,0,0.20);
    box-shadow: inset 0px 0px 5px 2px rgba(0,0,0,0.20);
  }
  .item{
    padding:5px;
    float:left;
    width: 33.33%;
    box-sizing: border-box;
    text-align: center;
  }
  &.range-0 .item-1{color:white;}
  &.range-1 .item-2{color:white;}
  &.range-2 .item-3{color:white;}
  &.range-0:before{left:0%;background-color:$primary;}
  &.range-1:before{left:33.33%;background-color: darken($primary,10);}
  &.range-2:before{left:66.66%;background-color: darken($primary,20);}
}
</style>



// WEBPACK FOOTER //
// src/components/SummaryRow.vue